import React from 'react';
import { Link } from 'react-router-dom';
import { SideBar } from '../Common/SideBar';
import { DashboardHeader } from '../Common/DashboardHeader';
import { Footer, Header } from '../Common';
import seller from '../../Models/seller';
import Request from '../../Models/Request';
import { Spinner } from 'reactstrap';
// import { connect } from 'react-redux';
// import { buyerLogin } from '../../../Action/login';

class SellerTransaction extends React.Component {
    constructor(props) {
        super(props);
        let x = JSON.parse(localStorage.getItem('info'))
        if (x === null || x === '' || x.user_type_id !== 2) {
            alert('ログインしてください')
            window.location.href = '/login/seller';
        };
        this.state = {
            minHeight: "475px",
            status: '',
            tradings: []
        };
        this.getTradingList();
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    getTradingList() {
        var x = JSON.parse(localStorage.getItem('info'))
        seller.getTradings(x.id).then(res => {
            this.setState({ tradings: res.data.payload, status: res.data.status })
        })
    }

    send(a) {
        let data = {
            'request_id': a
        }
        let r = window.confirm("完成しますか？");
        if (r === true) {
            Request.sendService(data).then(res => {
                if (res.data.status === 200) {
                    alert('ありがとうございました。');
                    window.location.reload();
                } else {
                    alert('システムエラーのため、この操作を完了する事ができませんでした。管理者に問い合わせるか、しばらく待ってから再度実行してください。');
                }
            })
                .catch(
                    console.log('asd')
                )
        } else {
            return;
        }

    }

    sellerTransactionView() {
        if (this.state.status === 200) {
            if (this.state.tradings.length === 0) {
                console.log(this.state.tradings.length)
                return (
                    <div>
                        <div className="mt-3"><span><img alt="" src={require("../../assets/images/message.png")} height="40" width='40' />&nbsp;&nbsp;</span></div>
                        <div className="mt-3"><span>取引ありません!</span></div>
                    </div>
                )
            }
            else {

                console.log(this.state.tradings.length)
                return (
                    <div style={{ backgroundColor: "white", minHeight: "550px", textAlign: "left" }}>
                        <div className="col-md-12 row ml-2" style={{ paddingTop: "3%", paddingBottom: "2%" }}>
                            <div className="col-md-3 font_12">
                                <b><i>取引内容 </i></b>
                            </div>
                            <div className="col-md-2 font_12">
                                <b><i>取引日</i></b>
                            </div>
                            <div className="col-md-2 font_12">
                                <b><i>取引金額</i></b>
                            </div>
                            <div className="col-md-2 font_12">
                                <b><i>状況</i></b>
                            </div>
                            <div className="col-md-2 font_12">
                                <b><i></i></b>
                            </div>
                            <div className="col-md-1 font_12">
                                {/* <b><i>状況</i></b> */}
                            </div>
                        </div>
                        {this.state.tradings.map((req, i = 1) =>
                            <div className="col-md-12 row ml-2" key={req.id} style={{ borderBottom: "1px solid #fbf8f8", paddingTop: "3%", paddingBottom: "2%" }}>
                                <div className="col-md-3 font_12">
                                    {/* <span className="font_12">  サービスID: {req.service_id}</span><br /> */}
                                    <Link to={{
                                        pathname: `/seller-request-details`,
                                        state: {
                                            id: req.id
                                        }
                                    }}>
                                        <b>{req.title}</b>
                                    </Link>
                                </div>
                                <div className="col-md-2 font_12" style={{}}>
                                    {(JSON.stringify(req.payment_date)).substring(1, 11)}
                                    {/* {req.proposed_delivery_time} */}
                                </div>
                                <div className="col-md-2 font_12" style={{}}>
                                    {req.proposed_budget}
                                </div>
                                <div className="col-md-2">
                                    {(() => {
                                        if (req.current_status === 'TRADING') {
                                            return (
                                                <div style={{ borderRdius: "8px", backgroundColor: "white", color: "green", fontSize: "10px" }}> 取引中</div>
                                            )
                                        } else if (req.current_status === 'UNDERESTIMATION') {
                                            return (
                                                <div style={{ borderRdius: "8px", backgroundColor: "white", color: "green", fontSize: "10px" }}>相談中</div>
                                            )
                                        } else if (req.current_status === 'COMPLETE') {
                                            return (
                                                <div style={{ borderRdius: "8px", backgroundColor: "white", color: "green", fontSize: "10px" }}>完成</div>
                                            )
                                        } else if (req.current_status === 'CANCEL') {
                                            return (
                                                <div style={{ borderRdius: "8px", backgroundColor: "white", color: "green", fontSize: "10px" }}>キャンセル</div>
                                            )
                                        } else if (req.current_status === 'DECLINED') {
                                            return (
                                                <div style={{ borderRdius: "8px", backgroundColor: "white", color: "green", fontSize: "10px" }}>拒否</div>
                                            )
                                        } else {
                                            return (
                                                <div style={{ borderRdius: "8px", backgroundColor: "white", color: "green", fontSize: "10px" }}>不明</div>
                                            )
                                        }
                                    })()}
                                </div>

                                <div className="col-md-3 font_12">
                                    <Link to={{
                                        pathname: `/seller-direct-message`,
                                        state: {
                                            buyer_id: req.buyer_id,
                                            seller_id: req.accepted_seller_id
                                        }
                                    }}>
                                        <button
                                            style={{
                                                padding: "5%", border: "1px solid cadetblue",
                                                borderRadius: "4px", color: "green", background: "white"
                                            }}>
                                            チャット
                                            </button>
                                    </Link>
                                    <span style={{ marginLeft: '10px' }}>
                                        {(() => {
                                            if (req.acceptance_status !== 'SERVED') {
                                                return (
                                                    <button
                                                        onClick={() => this.send(req.id)}
                                                        style={{
                                                            padding: "5%", border: "1px solid cadetblue", width: "64px",
                                                            borderRadius: "4px", color: "green", background: "white"
                                                        }}>
                                                        完了
                                                    </button>
                                                )
                                            }
                                        })()}
                                    </span>
                                </div>
                                {/* <div className="col-md-1 font_12">
                                    {(() => {
                                        if (req.acceptance_status !== 'SERVED') {
                                            return (
                                                <button
                                                    onClick={() => this.send(req.id)}
                                                    style={{
                                                        padding: "10%", border: "1px solid cadetblue",
                                                        borderRadius: "4px", color: "green", background: "white"
                                                    }}>
                                                    完了
                                                </button>
                                            )
                                        }
                                    })()}
                                </div> */}
                            </div>
                        )}
                    </div>
                )
            }
        } else {
            return (
                <div className="container-fluid">
                    <div className="container">
                        <div className="" style={{ height: '100px' }}></div>
                        <div className="text-center mt-3">
                            <Spinner color="primary" size="150" />
                        </div>
                    </div>
                </div>
            )
        }

    }
    sellerTransactionViewSmall() {
        if (this.state.status === 200) {
            if (this.state.tradings.length === 0) {
                console.log(this.state.tradings.length)
                return (
                    <div>
                        <div className="mt-3"><span><img alt="" src={require("../../assets/images/message.png")} height="40" width='40' />&nbsp;&nbsp;</span></div>
                        <div className="mt-3"><span>取引ありません!</span></div>
                    </div>
                )
            }
            else {
                return (
                    <div style={{ backgroundColor: "white", minHeight: "550px", textAlign: "left"}}>
                        {this.state.tradings.map((req, i = 1) =>
                            <div className="ml-2 pl-1" key={req.id} style={{ borderBottom: "1px solid #dadada", paddingTop: "3%", paddingBottom: "3%" }}>
                                <div className="font_12 pb-3" style={{paddingLeft: "15px"}}>
                                    {/* <span className="font_12">  サービスID: {req.service_id}</span><br /> */}
                                    <Link to={{
                                        pathname: `/seller-request-details`,
                                        state: {
                                            id: req.id
                                        }
                                    }}>
                                        <b class="gray">{req.title}</b>
                                    </Link>
                                </div>
                                <div className="font_12 row col" style={{}}>
                                    <div className="col-4 text-left">{req.proposed_budget}</div>
                                    <div className="col-4 text-right remove_pads">{(JSON.stringify(req.payment_date)).substring(1, 11)}</div>
                                    <div className="col-4 text-right pr-1">
                                        {(() => {
                                            if (req.current_status === 'TRADING') {
                                                return (
                                                    <div style={{ borderRdius: "8px", backgroundColor: "white", color: "green", fontSize: "10px" }}> 取引中</div>
                                                )
                                            } else if (req.current_status === 'UNDERESTIMATION') {
                                                return (
                                                    <div style={{ borderRdius: "8px", backgroundColor: "white", color: "green", fontSize: "10px" }}>相談中</div>
                                                )
                                            } else if (req.current_status === 'COMPLETE') {
                                                return (
                                                    <div style={{ borderRdius: "8px", backgroundColor: "white", color: "green", fontSize: "10px" }}>完成</div>
                                                )
                                            } else if (req.current_status === 'CANCEL') {
                                                return (
                                                    <div style={{ borderRdius: "8px", backgroundColor: "white", color: "green", fontSize: "10px" }}>キャンセル</div>
                                                )
                                            } else if (req.current_status === 'DECLINED') {
                                                return (
                                                    <div style={{ borderRdius: "8px", backgroundColor: "white", color: "green", fontSize: "10px" }}>拒否</div>
                                                )
                                            } else {
                                                return (
                                                    <div style={{ borderRdius: "8px", backgroundColor: "white", color: "green", fontSize: "10px" }}>不明</div>
                                                )
                                            }
                                        })()}
                                    </div>
                                </div>
                                <div className="col-12">&nbsp;</div>

                                <div className="font_12 text-center">
                                    <Link to={{
                                        pathname: `/seller-direct-message`,
                                        state: {
                                            buyer_id: req.buyer_id,
                                            seller_id: req.accepted_seller_id
                                        }
                                    }}>
                                        <button
                                            style={{
                                                padding: "1%", border: "1px solid cadetblue",
                                                borderRadius: "4px", color: "green", background: "white"
                                            }}>
                                            チャット
                                            </button>
                                    </Link>
                                    <span style={{ marginLeft: '10px' }}>
                                        {(() => {
                                            if (req.acceptance_status !== 'SERVED') {
                                                return (
                                                    <button
                                                        onClick={() => this.send(req.id)}
                                                        style={{
                                                            padding: "1%", border: "1px solid cadetblue", width: "64px",
                                                            borderRadius: "4px", color: "green", background: "white"
                                                        }}>
                                                        完了
                                                    </button>
                                                )
                                            }
                                        })()}
                                    </span>
                                </div>
                                {/* <div className="col-md-1 font_12">
                                    {(() => {
                                        if (req.acceptance_status !== 'SERVED') {
                                            return (
                                                <button
                                                    onClick={() => this.send(req.id)}
                                                    style={{
                                                        padding: "10%", border: "1px solid cadetblue",
                                                        borderRadius: "4px", color: "green", background: "white"
                                                    }}>
                                                    完了
                                                </button>
                                            )
                                        }
                                    })()}
                                </div> */}
                            </div>
                        )}
                    </div>
                )
            }
        } else {
            return (
                <div className="container-fluid">
                    <div className="container">
                        <div className="" style={{ height: '100px' }}></div>
                        <div className="text-center mt-3">
                            <Spinner color="primary" size="150" />
                        </div>
                    </div>
                </div>
            )
        }

    }


    render() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        if (isMobile) {
            return (
                <div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="mt-5 input_name big_font text-left" style={{ width: "100%",fontSize:'20px' }}>
                                    販売取引
                                </div>
                                <div className="chest">
                                    <div>
                                        <div className="row" style={{ marginLeft: '0px', marginRight: '-8px' }}>
                                            <div className="navigation" style={{ width: "33%",paddingRight:'3%' }}>
                                                <Link to={'/seller-estimate'} className="h-a" href="" style={{ fontSize: "9px" }}>見積り</Link>
                                            </div>
                                            <div className="navigation" style={{ borderTop: "4px solid #67b1e2", borderBottom: "1px solid white",fontSize: "9px",width: "33%",paddingRight:'3%' }}>
                                                <Link to={'/seller-transaction'} className="h-a" href=""><b>取引中</b></Link>
                                            </div>
                                            <div className="navigation" style={{ borderRight: "0px",width: "32%",paddingRight:'3%'}}>
                                                <Link to={'/seller-complete-cancel'} className="h-a" href="" style={{ fontSize: "9px" }}>完成・キャンセル</Link>
                                            </div>
                                        </div>
                                        <div>
                                            <div colSpan="3">
                                                <div className="min-height">
                                                    {this.sellerTransactionViewSmall()}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            )
        } else {
            return (
                <div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 "></div>
                    <div className="container-fluid">
                        <div className="container">
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-4 input_name">
                                        <SideBar />
                                    </div>
                                    <div className="col-md-8">
                                        <div className="mb-1 input_name big_font text-left" style={{ width: "100%" }}>
                                            販売取引
                                    </div>
                                        <div className="chest">
                                            <div>
                                                <div className="row" style={{ marginLeft: '0px', marginRight: '-8px' }}>
                                                    <div className="navigation">
                                                        <Link to={'/seller-estimate'} className="h-a" href="">見積り</Link>
                                                    </div>
                                                    <div className="navigation" style={{ borderTop: "4px solid #67b1e2", borderBottom: "1px solid white" }}>
                                                        <Link to={'/seller-transaction'} className="h-a" href=""><b>取引中</b></Link>
                                                    </div>
                                                    <div className="navigation" style={{ borderRight: "0px" }}>
                                                        <Link to={'/seller-complete-cancel'} className="h-a" href="">完成・キャンセル</Link>
                                                    </div>
                                                </div>
                                                {/* <tr>
                                                <td colSpan="3">
                                                    <div className="transaction-inputs col-md-12 row ml-2">
                                                        <div className="col-md-4" style={{ textAlign: "center" }}><input className="oneofthree" style={{ width: "80%" }} /></div>
                                                        <div className="col-md-4" style={{ textAlign: "center" }}>
                                                            <select className="oneofthree" style={{ width: "80%" }}>
                                                                <option>

                                                                </option>
                                                            </select>
                                                        </div>
                                                        <div className="col-md-4" style={{ textAlign: "center" }}>
                                                            <button className="third-button" style={{ paddingLeft: "2%", paddingRight: "2%", fontSize: "12px" }}>Narrow Down</button>
                                                            <p>search by text and category to be added later</p>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr> */}
                                                <div>
                                                    <div colSpan="3">
                                                        <div className="min-height">
                                                            {this.sellerTransactionView()}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            );
        }
    }
}

// const mapStateToProps = (state) => ({
//     buyerLogin: state.buyerLogin,
// });

// BuyerLogin = connect(mapStateToProps, { buyerLogin })(BuyerLogin);

export { SellerTransaction };